<style lang="less" scoped>
.container {
  background-color: #fff;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  h3 {
    font-size: 16px;
  }
  .title {
    font-size: 14px;
  }
  .order {
    font-size: 12px;
  }
  .nav {
    display: flex;
    justify-content: space-between;
  }
  .order__info {
    border: 1px solid rgba(245, 245, 245, 1);
    padding: 20px;
  }
  .pay__info {
    border: 1px solid rgba(245, 245, 245, 1);
    border-bottom: none;
    padding-top: 16px;
    padding-left: 18px;
    .offline{
      font-size: 12px;
      line-height: 20px;
      color: rgba(0,0,0,.65);
      b{
        color: #000;
      }
      .info{
        margin: 12px 0;
      }
    }
  }
  .pay__img {
    width: 156px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid rgba(230, 230, 230, 1);
    display: flex;
    justify-content: flex-start;
    padding-left: 9px;
    align-items: center;
  }
  .alipay img {
    width: 87px;
    height: 29px;
  }
  .wxpay img {
    width: 111px;
    height: 25px;
  }
  .ant-radio-wrapper-checked .pay__img {
    border: 1px solid rgba(252, 136, 48, 1);
  }
  .methods {
    display: flex;
    flex-flow: column;
    .ant-radio-wrapper {
      width: max-content;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }
  }
  .footer {
    position: fixed;
    width: 100%;
    height: 72px;
    background-color: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content:flex-end;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
  }
  .pay--off{
    margin-left: 24px;
    margin-right: 25px;
  }
  .qrcode {
    width: 212px;
    height: 212px;
  }
}
</style>
<template>
  <div class="container">
    <div class="nav">
      <div class="info">
        <h3>请核对订单信息</h3>
        <p class="order">订单号: {{ vo.out_trade_no }}</p>
      </div>
      <h3 class="money">预付款 应付: {{ vo.amount | currency("¥", 2) }}</h3>
    </div>
    <div class="order__info">
      <p>
        {{ vo.user_info.legal_person }} {{ vo.user_info.com_name }}
        {{ vo.user_info.com_address }} {{ vo.user_info.con_details }}
      </p>
      <p>{{ vo.project_name }}</p>
      <p>{{ vo.version_name }}</p>
      <p>{{ vo.platform_list.join(",") }}</p>
      <p>1级功能: {{ vo.feature_count }}个</p>
      <p>2级功能: {{ vo.function_count }}个</p>
    </div>
    <div class="pay__info">
      <h4 class="title">支付方式</h4>
      <a-tabs
        type="card"
        :animated="false"
        defaultActiveKey="online"
        @change="changePayType"
      >
        <a-tab-pane tab="在线支付" key="online">
          <a-radio-group class="methods" v-model="vo.payMethod">
            <a-radio
              :key="index"
              v-for="(pay, index) in payList"
              :value="pay.method"
            >
              <div
                :class="{
                  [pay.method]: true
                }"
                class="pay__img"
              >
                <img :src="pay.icon" />
              </div>
            </a-radio>
          </a-radio-group>
        </a-tab-pane>
        <a-tab-pane class='offline' tab="线下转账" key="offline" forceRender>
          <!-- 线下转账文案 blabla {{ vo.out_trade_no }} -->
          <div class="title">
            <b>线下汇款结算流程：</b>1. 通过专属帐号进行线下汇款充值 > 2. 款项到达账户余额后，对未支付订单进行支付
          </div>
          <div class="info">
            <div>
              -  宜创（北京）科技有限公司  银行账户信息
            </div>
            <div>
              -  开户名：宜创（北京）科技有限公司
            </div>
            <div>
              -  开户行: 招商银行股份有限公司北京清华园支行
            </div>
            <div>
              -  帐号: 1109 1332 6110 401
            </div>
            <div>
              -  订单号: {{ vo.out_trade_no }}
            </div>
          </div>
          <div class="foot">
            <b>
              注意事项 ：请在汇款时备注订单编号（如: {{ vo.out_trade_no }}）方便我公司追踪查询。如缺少该信息，付款处理过程会延迟，耽误您的开发。
            </b>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="footer">
      支付金额: {{ vo.amount | currency("¥", 2) }}
      <a-button
        class="pay--off"
        @click="onPay"
        type="primary"
        :disabled="vo.payType === 'offline'"
        >下一步</a-button
      >
    </div>
    <a-modal
      title="微信支付"
      v-model="vo.wxPay"
      @ok="closeWxPay"
      okText="确认"
      cancelText="取消"
      :footer="null"
    >
      <div class="qr__box">
        <canvas ref='qr' class="qrcode"></canvas>
        <span>请使用微信扫描二维码以完成支付</span>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { stringify } from 'query-string'
import qrcode from 'qrcode'
const mock = {
  _id: '', // 订单id
  project_id: '', // 项目id
  version_id: '', // 版本id
  version_name: '版本名称', // 版本名称
  project_name: '畅修保', // 项目名称
  platform_list: ['iOS', 'Android'], // 平台列表
  feature_count: 10, // 一级功能个数
  function_count: 100, // 二级功能个数
  hex_create_time: 123412312321,
  hex_update_time: 123439232912,
  amount: 100000, // 订单价格
  subject: '', // 订单标题
  out_trade_no: 'dsfhjkfdfhkshjkfd', // 订单号
  status: '', // 订单状态
  pay_status: '', // 订单状态解释
  qr_code: '', // 二维码支付地址
  user_id: '', // 下单人id
  method: 'alipay', // 支付方式
  user_info: {
    _id: '', // 主体信息id
    partyA: '', // 甲方
    credit_code: '', // 统一社会信用代码
    legal_person: '陈天航', // 法定代表人
    com_address: '北京', // 公司地址
    con_details: '186****123', // 联系方式
    com_name: '宜创 (北京) 科技有限公司', // 单位名称
    user_id: '' // 用户id
  } // 合同主体信息
}
export default {
  data () {
    return {
      // mock
      vo: { ...mock, payMethod: 'alipay', payType: 'online', wxPay: false },
      loopTimer: null,
      payList: [
        { method: 'alipay', name: '支付宝支付', icon: require('./alipay.png') },
        { method: 'wxpay', name: '微信支付', icon: require('./wechat.png') }
      ]
    }
  },
  beforeMount () {
    this.fetchOrder().then(r => {
      this.vo = {
        ...this.vo,
        ...r
      }
      console.log('vo', this.vo.amount)
      const t = this
      if (r.pay_status) {
        this.$warning({
          title: '当前订单状态',
          content: '该订单已经完成支付',
          onOk () {
            t.$router.push({
              path: '/pay/process/finish',
              query: t.$route.query
            })
          }
        })
      }
    })
  },
  methods: {
    fetchOrder () {
      return this.$post('/wuwei/api/orders/payProcess', {
        order_id: this.$route.query.order_id
      }).then(data => {
        return data.result
      })
    },
    postPay () {
      return this.$post('/wuwei/api/orders/payment', {
        returnUrl: `${window.location.origin}/#/pay/process/done?${stringify(this.$route.query)}`,
        order_id: this.$route.query.order_id,
        method: this.vo.payMethod
      }).then(data => {
        return data.result
      })
    },
    changePayType (key) {
      this.vo.payType = key
    },
    closeWxPay () {
      this.vo.wxPay = false
      clearTimeout(this.loopTimer)
    },
    // 心跳检测
    loopCheckPay () {
      const d = 1000
      this.loopTimer = setTimeout(() => {
        this.fetchOrder().then(r => {
          if (r.pay_status) {
            clearTimeout(this.loopTimer)
            this.loopTimer = null
            this.$router.push({
              path: '/pay/process/done',
              query: this.$route.query
            })
          } else {
            this.loopCheckPay()
          }
        })
      }, d)
    },
    qrcode (text, el) {
      return new Promise((resolve, reject) => {
        qrcode.toCanvas(el, text, {
          width: 212,
          height: 212,
          errorCorrectionLevel: 'H'
        }, err => {
          if (err) {
            reject(err)
            return
          }
          resolve()
        })
      })
    },
    // 微信支付
    wxpay () {
      this.postPay().then(result => {
        if (result && result.qr_code) {
          this.vo.wxPay = true
          this.$nextTick(() => {
            this.qrcode(result.qr_code, this.$refs.qr).then(this.loopCheckPay.bind(this))
          })
        }
      })
    },
    // 支付宝支付
    alipay () {
      this.postPay().then(result => {
        if (result && result.qr_code) {
          window.location.href = result.qr_code
        }
      })
    },
    onPay () {
      if (typeof this[this.vo.payMethod] === 'function') {
        this[this.vo.payMethod]()
      }
    }
  }
}
</script>
